import React from 'react'
import { Link } from 'gatsby'
import CookieConsent from 'react-cookie-consent'

// Components
import Footer from './footer'
import Header from './header'

const Layout = ({ children }) => {
  return (
    <div className='flex min-h-screen flex-col bg-gray-100 font-light text-gray-900 subpixel-antialiased'>
      <Header />
      <main className='pb-3 md:pb-10' role='main' id='main'>
        {children}
      </main>
      <Footer />
      <CookieConsent
        location='bottom'
        buttonText='Accept'
        declineButtonText='Decline'
        disableStyles
        containerClasses='z-30 fixed inset-x-0 bg-gray-900 text-white px-4 py-2 flex flex-col sm:flex-row items-center justify-center'
        buttonClasses='ml-2 button'
        declineButtonClasses='ml-2 button bg-transparent font-normal'
        contentClasses='py-2 flex-1'
        enableDeclineButton
        cookieName='gatsby-gdpr-google-tagmanager'>
        We use cookies to collect information about how you use {process.env.GATSBY_COMPANY_NAME}. See our{' '}
        <Link to='/privacy-policy' className='font-medium underline'>
          Privacy Policy
        </Link>{' '}
        to see how we use this information.
      </CookieConsent>
    </div>
  )
}

export default Layout
